import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import SearchInput from '../../../common/components/UI/Search/SearchInput';


/**
 * @param {{
 *  searchValue: string;
 *  handleSearchFilter: (searchInput: string ) => void;
 * }} param0
 */
const ArchiveTableHeader = ({
    searchValue,
    handleSearchFilter,
}) => {
    const { t } = useTranslation('archive', { keyPrefix: 'header'});

    return (
        <React.Fragment>
            <Grid container>
                <Grid item xs={6} >
                    {!!handleSearchFilter && (
                        <SearchInput
                            fullWidth={true}
                            value={searchValue}
                            placeholder={t('searchBarPlaceholder')}
                            onChange={handleSearchFilter}
                        />)}
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
export default ArchiveTableHeader;